import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { projectScopeKey } from './getScope';

const url = `${PREFIX_URL}/projects/:projectId/scope`;

type UpdateScopeResponse = { 'transactions-volume': number };

type UpdateScopeDTO = {
  projectId: string;
  transactionsVolume: number;
  estimatedTimeAllocated: number;
};

export const updateScope = ({
  projectId,
  transactionsVolume,
  estimatedTimeAllocated,
}: UpdateScopeDTO): Promise<UpdateScopeResponse> => {
  const URL = generateRoutePath(url, { projectId });

  return axios.put(URL, {
    'transactions-volume': transactionsVolume,
    'estimated-time-allocation-hrs': estimatedTimeAllocated,
  });
};

type UseUpdateScopeOptions = {
  projectId: number;
  config?: MutationConfig<typeof updateScope>;
};

export const useUpdateScope = ({ projectId, config }: UseUpdateScopeOptions) => {
  return useMutation({
    ...config,
    onSuccess: (data) => {
      queryClient.setQueryData([projectScopeKey, projectId], () => ({
        'transactions-volume': data['transactions-volume'],
        'estimated-time-allocation-hrs': data['estimated-time-allocation-hrs'],
      }));
    },
    mutationFn: (props: UpdateScopeDTO) => updateScope(props),
  });
};
